import { useParams, Link } from 'react-router-dom'
import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { getProject } from '../api/projects'
import { getElectricalPanelById } from '../api/electricalPanels'
import Devices from './Devices'

export default function DevicesPage() {
  const { projectId, panelId } = useParams<{ projectId: string; panelId?: string }>()

  const { data: project, isLoading: projectLoading } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => getProject(Number(projectId)),
    enabled: !!projectId,
  })

  const { data: panel, isLoading: panelLoading } = useQuery({
    queryKey: ['electrical-panel', panelId],
    queryFn: () => getElectricalPanelById(Number(panelId)),
    enabled: !!panelId,
  })

  // Устанавливаем заголовок страницы
  useEffect(() => {
    if (panel) {
      document.title = `Устройства. ${panel.proj_id} - ESS-2`
    } else {
      document.title = 'Система электрических схем ESS-2'
    }
    
    // Восстанавливаем заголовок при размонтировании
    return () => {
      document.title = 'Система электрических схем ESS-2'
    }
  }, [panel])

  if (projectLoading || (panelId && panelLoading)) {
    return <div className="text-center py-8">Загрузка...</div>
  }

  if (!project) {
    return <div className="text-center py-8 text-red-600">Проект не найден</div>
  }

  if (panelId && !panel) {
    return <div className="text-center py-8 text-red-600">Электрический щит не найден</div>
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <Link to={`/projects/${projectId}`} className="text-blue-600 hover:text-blue-800 mb-2 inline-block">
            ← Назад к {project.name}
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">
            Устройства. {panel ? `${panel.proj_id} (${panel.name})` : 'Устройства'}
          </h1>
        </div>
      </div>

      {/* Devices Component */}
      <Devices 
        projectId={Number(projectId!)} 
        electricalPanelId={panelId ? Number(panelId) : undefined}
      />
    </div>
  )
} 